<template>
    <section>
        <div class="container container--fluid">
            <v-card>
                    <v-tabs
                            background-color="transparent"
                            color="basil"
                    >
                        <v-tabs-slider color="primary"></v-tabs-slider>
                        <v-tab
                                :to="{ name: 'Tickets', query : { orders : [{ column_name : 'assigned_user_id', value : 'desc'},{ column_name : 'created_at', value : 'desc'}], filters : [{ operand : 'IsEqualToOrNull', value : user.user_id, column_name : 'assigned_user_id'},{ operand : 'IsEqualTo', value : 'pending', column_name : 'status'}]} }"
                                link
                                exact
                        >
                            نیاز به بررسی
                            <v-chip
                                    v-if="totalPendingCount > 0"
                                    :loading="loadingTotalPendingCount"
                                    color="error"
                                    x-small
                            > {{totalPendingCount}} </v-chip>
                        </v-tab>
                        <v-tab
                                :to="{ name: 'Tickets', query : { orders : [{column_name : 'updated_at', value : 'asc'}], filters : [{ operand : 'IsEqualTo', value : user.user_id, column_name : 'assigned_user_id'},{ operand : 'IsEqualTo', value : 'ongoing', column_name : 'status'}]} }"
                                link
                                exact
                        >
                            درحال بررسی
                        </v-tab>
                        <v-tab
                                :to="{ name: 'Tickets', query : { orders : [{column_name : 'updated_at', value : 'desc'}],filters : [{ operand : 'IsEqualTo', value : user.user_id, column_name : 'assigned_user_id'},{ operand : 'IsEqualTo', value : 'answered', column_name : 'status'}]} }"
                                link
                                exact
                        >
                            پاسخ داده شده
                        </v-tab>
                        <v-tab
                                :to="{ name: 'Tickets', query : { orders : [{column_name : 'updated_at', value : 'desc'}], filters : [{ operand : 'IsEqualTo', value : user.user_id, column_name : 'assigned_user_id'},{ operand : 'IsEqualTo', value : 'closed', column_name : 'status'}]} }"
                                link
                                exact
                        >
                            بسته
                        </v-tab>
                        <v-tab
                                :to="{ name: 'Tickets', query : { page : 1, count : 10} }"
                                link
                                exact
                        >
                            همه
                        </v-tab>
                    </v-tabs>
                    <v-card-title class="headline">
                        <v-spacer></v-spacer>
                        <v-btn
                                small
                                color="primary"
                                class="white--text"
                                @click="showForm()"
                                v-if="1 || userCan('users_create')"
                        >
                            {{$t('create')}}
                            <v-icon right dark>mdi-plus</v-icon>
                        </v-btn>
                        <v-btn
                            icon
                            small
                            @click="fetch()"
                        >
                            <v-icon right dark>mdi-reload</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-data-table
                            class="text-capitalize"
                            :headers="headers"
                            :items="items"
                            :loading="loading"
                            :options.sync="options"
                            :server-items-length="total"
                            :page="options.page"
                            :items-per-page="options.itemsPerPage"
                            :footer-props="footerProps"
                    >
                        <template v-slot:top>
                            <div class="d-flex justify-start mb-6">
                                <v-text-field
                                        append-icon="mdi-magnify"
                                        v-model="search"
                                        :loading="!!searchHandler"
                                        label="کد پیگیری"
                                        class="mx-4 pa-1"
                                ></v-text-field>
                                <v-select
                                        clearable
                                        v-model="filters.status.value"
                                        :label="$t('status')"
                                        :items="statusOptions"
                                        item-text="value"
                                        item-value="key"
                                        class="mx-4 pa-1"
                                ></v-select>
                                <UserSelect
                                    clearable
                                    v-model="filters.user_id.value"
                                    :label="$t('user')"
                                    placeholder="نام و نام خانوادگی  یا شماره همراه"
                                    className="ml-5"
                                ></UserSelect>
                                <UserSelect
                                    clearable
                                    v-model="filters.assigned_user_id.value"
                                    :label="$t('assigned_user_id')"
                                    placeholder="نام و نام خانوادگی  یا شماره همراه"
                                    className="ml-5"
                                ></UserSelect>
                            </div>

                        </template>
                        <template #item.ticket_number="{item}">
                            {{item.ticket_number}}
                            <v-chip
                                    v-if="!item.assigned_user_id"
                                    color="error"
                                    x-small
                            > جدید </v-chip>
                        </template>
                        <template #item.user_id="{item}">
                            <router-link
                                    :to="{name : 'Tickets', query : { filters : [{column_name : 'user_id', operand : 'IsEqualTo', value : item.user_id}]}}"
                                    color="red"
                                    text-color="white"
                                    v-bind="attrs"
                                    v-on="on"
                            >
                                {{ item.user_fullname}} {{(item.user_mobile)}}
                            </router-link>
                        </template>
                        <template #item.assigned_user_id="{item}">
                            <router-link
                                    :to="{name : 'Tickets', query : { filters : [{column_name : 'assigned_user_id', operand : 'IsEqualTo', value : item.assigned_user_id}]}}"
                                    color="red"
                                    text-color="white"
                                    v-bind="attrs"
                                    v-on="on"
                            >
                                {{ item.assigned_user_fullname}} {{(item.assigned_user_mobile)}}
                            </router-link>
                        </template>
                        <template #item.department="{item}">
                            {{$t("ticket_department")[item.department]}}
                        </template>
                        <template #item.status="{item}">
                            <v-chip
                                    small
                                    class="ma-2"
                                    :color="getStatusColor(item)"
                                    text-color="white"
                            >
                                {{$t("ticket_status")[item.status]}}
                            </v-chip>
                        </template>
                        <template #item.created_at="{item}">
                            {{ getJalaliDate(item.created_at * 1000) }}
                        </template>
                        <template #item.actions="{item}">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                            :to="{name : 'TicketDetails', params : { ticketNumber : item.ticket_number } }"
                                            icon small @click="showItem = item" v-bind="attrs" v-on="on" link>
                                        <v-icon>mdi-eye</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{$t('details')}}</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
            </v-card>
            <Form
                    v-if="item"
                    :item="item"
                    @close="item = null"
                    @submit="fetch"
            ></Form>
        </div>
    </section>
</template>

<script>
    import RequestList from "../services/RequestList";
    import Service from "../services/TicketService";
    import UserSelect from '../components/UserSelect'
    import Form from '../components/TicketForm'
    import CRUDMixin from '../mixins/CRUDMixin'
    import { mapGetters } from 'vuex';

    export default {
        mixins : [CRUDMixin],

        components : {
            Form,
            UserSelect
        },
        mounted() {
            this.handlerTotalPendingCount = setTimeout( this.syncTotalPendingCount, 3000);
        },
        beforeDestroy(){
          clearTimeout(this.handlerTotalPendingCount);
        },
        data() {
            return {
                handlerTotalPendingCount : null,
                item : null,
                loading : false,
                headers : [
                    {
                        text: this.$t('ticket_number'),
                        value: 'ticket_number',
                    },
                    {
                        text: this.$t('user'),
                        value: 'user_id',
                    },
                    {
                        text: this.$t('assigned_user_id'),
                        value: 'assigned_user_id',
                    },
                    {
                        text: this.$t('subject'),
                        value: 'subject',
                    },
                    {
                        text: this.$t('department'),
                        value: 'department',
                    },
                    {
                        text: this.$t('status'),
                        value: 'status',
                    },
                    {
                        text: this.$t('created_at'),
                        value: 'created_at',
                    },
                    {
                        text: this.$t('action'),
                        value: 'actions',
                    }
                ],
                filters : {
                    ticket_number : {
                        column_name : 'ticket_number',
                        operand : 'Contains',
                        value : undefined
                    },
                    status : {
                        column_name : 'status',
                        operand : 'IsEqualTo',
                        value : undefined
                    },
                    user_id : {
                        column_name : 'user_id',
                        operand : 'IsEqualTo',
                        value : undefined
                    },
                    assigned_user_id : {
                        column_name : 'assigned_user_id',
                        operand : 'IsEqualTo',
                        value : undefined
                    },
                },
                items : [],
                totalPendingCount : 0,
                loadingTotalPendingCount : false,
                search : null,
                searchHandler : null,
            }
        },
        watch: {
            search(str){
                if( this.searchHandler ){
                    clearTimeout(this.searchHandler);
                }
                if(!str && this.filters.ticket_number.value){
                    this.filters.ticket_number.value = null;
                }

                if( str.length <= 3 ){
                    return '';
                }
                this.searchHandler = setTimeout( () => {
                    this.filters.ticket_number.value = str;
                    this.searchHandler = null;
                }, 1000);
            },
            dialog (val) {
                !val && this.close()
            },
            filters: {
                handler(filters) {
                    let filtersQuery = [];


                    Object.values(filters).map( filter => {
                        if(filter.value){
                            filtersQuery.push({...filter});
                        }
                    });

                    this.$router.push({
                        query : {
                            filters : filtersQuery,
                            page : 1,
                            count : this.options.itemsPerPage
                        }
                    }).catch(err => err);
                },
                deep: true,
            },
        },
        computed: {
            statusOptions(){
                return Object.keys(this.$t("ticket_status")).map(key => {
                    return {
                        key,
                        value: this.$t("ticket_status")[key]
                    }
                });
            },
            ...mapGetters({
                user: 'auth/user'
            })
        },
        methods: {
            getStatusColor(ticket){
                let color = null;
                switch (ticket.status){
                    case 'pending' :
                        color = null;
                        break;
                    case 'ongoing' :
                        color = 'warning';
                        break;
                    case 'answered' :
                        color = 'info';
                        break;
                    case 'closed' :
                        color = 'success';
                        break;
                }
                return color;
            },
            async fetch() {
                this.loading = true;
                
                let page = this.$route.query.page || 1;
                let count = this.$route.query.count || this.options.itemsPerPage;

                let requestList = new RequestList();

                requestList.setFilters(this.$route.query.filters || []);
                requestList.addOrder('id','desc');
                requestList.setPage(page, count);

                try {
                    let {data} = await Service.list(requestList);
                    this.items = data.value.tickets;
                    this.total = data.value.total;
                } finally {
                    this.loading = false;
                }
            },
            async syncTotalPendingCount(){
                this.loadingTotalPendingCount = true;

                let requestList = new RequestList();
                requestList.setPage(1, 1);
                requestList.addFilter('status','IsEqualTo','pending');
                requestList.addFilter('assigned_user_id','IsEqualToOrNull',this.user.user_id);

                try {
                    let {data} = await Service.list(requestList);
                    this.totalPendingCount = data.value.total;
                } finally {
                    this.loadingTotalPendingCount = false;
                }
            },
            showForm(item) {
                item = item || Service.getDefault();
                this.item = item;
            }

        }
    }
</script>